module.exports = __webpack_public_path__ + "static/media/drive_moto3.f80f1b7a.jpg";